const PORTFOLIO_IMGS = [
  "https://static.prod-images.emergentagent.com/jobs/5d609f59-ef3b-4635-81e0-3a6a2e70cc39/images/8350268cba0c980220db8cc8eae217067eeddb6f0ad6112ade4c44278c221dcc.png",
  "https://images.unsplash.com/photo-1764397301085-516f4d5bfdc5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwxfHxpbmR1c3RyaWFsJTIwbWFpbnRlbmFuY2UlMjBwaXBpbmd8ZW58MHx8fHwxNzc4ODM5MDgxfDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1599707254554-027aeb4deacd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxlbmdpbmVlcnMlMjBjb25zdHJ1Y3Rpb24lMjBzaXRlfGVufDB8fHx8MTc3ODgzOTA4MXww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1504307651254-35680f356dfd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxlbmdpbmVlcnMlMjBjb25zdHJ1Y3Rpb24lMjBzaXRlfGVufDB8fHx8MTc3ODgzOTA4MXww&ixlib=rb-4.1.0&q=85",
];

const Portfolio = ({ t }) => {
  return (
    <section
      id="portfolio"
      data-testid="portfolio-section"
      className="relative bg-[#060d18] py-24 sm:py-32 text-white overflow-hidden"
    >
      {/* Subtle pattern */}
      <div className="absolute inset-0 opacity-[0.04] pointer-events-none"
        style={{
          backgroundImage: "linear-gradient(#fff 1px, transparent 1px)",
          backgroundSize: "100% 60px",
        }}
      />

      <div className="relative bid-container">
        <div className="max-w-3xl mb-16">
          <p className="bid-overline text-[#d4af37] mb-4">{t.portfolio.overline}</p>
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl font-display font-black tracking-tight leading-tight"
            data-testid="portfolio-title"
          >
            {t.portfolio.title}
          </h2>
          <p className="mt-4 text-base sm:text-lg text-white/70 leading-relaxed">
            {t.portfolio.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-6">
          {t.portfolio.items.map((p, i) => {
            // Bento style: first card spans 7, second 5, third 5, fourth 7
            const span = i % 4 === 0 || i % 4 === 3 ? "lg:col-span-7" : "lg:col-span-5";
            return (
              <article
                key={i}
                className={`group relative overflow-hidden border border-white/10 bg-[#0a192f] ${span}`}
                data-testid={`portfolio-card-${i}`}
              >
                <div className="relative h-72 lg:h-80 overflow-hidden">
                  <img
                    src={PORTFOLIO_IMGS[i % PORTFOLIO_IMGS.length]}
                    alt={p.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0a192f] via-[#0a192f]/40 to-transparent" />
                </div>
                <div className="absolute top-5 left-5">
                  <span className="bg-[#d4af37] text-[#0a192f] px-3 py-1 font-display font-black text-xs uppercase tracking-wider">
                    {p.tag}
                  </span>
                </div>
                <div className="p-7 sm:p-9">
                  <h3 className="font-display text-xl sm:text-2xl font-bold leading-snug">
                    {p.title}
                  </h3>
                  <p className="mt-3 text-sm text-white/70 leading-relaxed">{p.desc}</p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
